import React from "react";
// import "../CSS/reset.css";

export default function Recovered() {
    return (
        <div>
            <div class="main-container" style={{ minHeight: 370, color: "green" }}>
                <div class="box-container">
                    <h2>👍 Password succesfully reset</h2>
                </div>
            </div>
        </div>
    );
}